import PasswordInput from '../components/PasswordInput';
import AuthLayout from '../components/AuthLayout';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      setError('無効なリンクです。パスワードリセット申請からやり直してください。');
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    if (newPassword.length < 6) {
      setError('パスワードは6文字以上である必要があります');
      return;
    }

    setIsLoading(true);

    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000';
      await axios.post(`${apiUrl}/auth/reset-password`, {
        token,
        newPassword
      });

      setSuccess(true);

      // 3秒後にログイン画面に遷移
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error: any) {
      setError(error.response?.data?.error || 'パスワードリセットに失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  if (!token && !error) {
    return (
      <AuthLayout title="パスワードの再設定">
        <p>読み込み中...</p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="パスワードの再設定"
      description="新しいパスワードを設定してください。"
    >
      <h1>パスワードリセット</h1>

      {error && !success && (
        <div style={{ color: 'red', marginBottom: '20px', padding: '10px', border: '1px solid red', borderRadius: '4px' }}>
          {error}
        </div>
      )}

      {success ? (
        <div>
          <div style={{ color: 'green', marginBottom: '20px', padding: '10px', border: '1px solid green', borderRadius: '4px' }}>
            パスワードが正常にリセットされました。<br />
            3秒後にログイン画面に移動します...
          </div>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Link to="/login" style={{ color: '#2563EB' }}>すぐにログイン画面に移動</Link>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            新しいパスワードを入力してください。
          </p>

          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="newPassword">新しいパスワード:</label>
            <PasswordInput
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              placeholder="6文字以上"
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              disabled={!token}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="confirmPassword">パスワード確認:</label>
            <PasswordInput
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              placeholder="もう一度入力"
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              disabled={!token}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading || !token}
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: !token ? '#ccc' : '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: (isLoading || !token) ? 'not-allowed' : 'pointer',
              marginBottom: '15px'
            }}
          >
            {isLoading ? 'リセット中...' : 'パスワードをリセット'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <Link to="/login" style={{ color: '#2563EB' }}>ログイン画面に戻る</Link>
          </div>
        </form>
      )}
    </AuthLayout>
  );
};

export default ResetPasswordPage;
